import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

interface FieldState {
  value: unknown;
  isValid: boolean | null;
  errorMessage?: string | null;
}

interface FormState {
  [fieldName: string]: FieldState;
}

const initialState: FormState = {};

const formSlice = createSlice({
  name: 'form',
  initialState,
  reducers: {
    setField: (
      state,
      action: PayloadAction<{
        fieldName: string;
        value: unknown;
        isValid: boolean | null;
        errorMessage?: string | null;
      }>,
    ) => {
      const { fieldName, value, isValid, errorMessage = null } = action.payload;
      state[fieldName] = { value, isValid, errorMessage };
    },

    resetForm: (state) => {
      for (const key of Object.keys(state)) {
        state[key] = { value: '', isValid: null, errorMessage: null };
      }
    },

    clearForm: () => {
      return {};
    },
  },
});

export const { setField, resetForm, clearForm } = formSlice.actions;

export default formSlice.reducer;
export const selectFormState = (state: { form: FormState }) => state.form;
export const selectFormField = (fieldName: string) => (state: { form: FormState }) =>
  state.form[fieldName];
export const selectFormStringField =
  (fieldName: string) =>
  (state: { form: FormState }): string => {
    const val = state.form[fieldName]?.value;
    return typeof val === 'string' ? val : '';
  };
